export default __webpack_public_path__ + "static/media/error-alert.574eeb9c.svg";